import React from 'react';
import UnderConstruction from 'common/components/UnderConstruction';

// TODO change nav
const Contacts = () => {
  return (
    <div>
      <h1 style={{ textAlign: 'center', marginTop: '20px' }}>Contact Us</h1>
      <UnderConstruction />
    </div>
  );
};

export default Contacts;